export default "__VITE_ASSET__4cea55cc__"